<div [formGroup]="group" class="row align-baseline"   [class.form-group]="!group.disabled">

  <label *ngIf="(group.enabled || config.presentation === 'filter' || config.presentation === 'detail')
                || (config.presentation === 'edit' && config.options.labelShowInDetail)"
         class="control-label"
         [class.col-sm-4]="config.options.inputOptions"
         [class.col-sm-3]="!config.options.inputOptions">{{config.label | translate:locale.language}}</label>

  <div class="parent-container"
       [class.col-sm-7]="config.options.inputOptions"
       [class.col-sm-9]="!config.options.inputOptions">

    <div *ngIf="getControlNameDetail && getControlNameDetail.enabled && config.presentation === 'edit'" style="width: 100%;" class="inputStyle">
      <span *ngIf="!isEnabled && config.options?.checkboxEndlessMode" class="input-group-addon container-checkbox" style="width: 5%;">
          <input type="checkbox" class="form-check-input" [checked]="endLessDate" (change)="checkboxChange($event)">
          <span class="checkmark"></span>
      </span>
      <input  *ngIf="!isEnabled && !endLessDate"(ngModelChange)="typeaheadQueryHasChanged($event)"
             autocomplete="off"
             [class.control-disabled]="isEnabled"
             class="form-control"
              style="font-size: 18px"
             ctrl-error
             id="{{config.label}}"
             [formControlName]="getControlName"
             [required]="getFormByControlName.errors !== null &&  getFormByControlName.errors['required']"
             [typeahead]="datas"
             [typeaheadAsync]="config.options.typeaheadAsync ? config.options.typeaheadAsync : false"
             [typeaheadOptionsLimit]="config.options.typeaheadOptionsLimit ? config.options.typeaheadOptionsLimit : 25"
             [typeaheadOptionsInScrollableView]="20"
             [typeaheadMinLength]="0"
             [typeaheadScrollable]="true"
             [typeaheadGroupField]="config.options.region"
             [typeaheadOptionField]="config.options.vue"
             [typeaheadItemTemplate]="config.options.useTemplate ? customItemTemplate : null"
             (typeaheadOnSelect)="typeaheadOnSelect($event)"
             (typeaheadNoResults)="noResult($event)"
             placeholder="{{config.placeholder | translate:locale.language}}">
      <ng-template  #customItemTemplate let-model="item">
        <span> {{model[config.options.vue]}}</span>
        <span *ngFor="let item of config.options.useTemplate; let i = index"  style="color: lightgray">
          {{model[item]}}
        </span>
      </ng-template>
      <span *ngIf="!isEnabled &&  endLessDate" class="form-control disabled endLessDate" >{{config.options?.checkboxEndlessModeText | translate:locale.language}}</span>
      <span *ngIf="(getFormByControlName.validator && getFormByControlName.validator.length &&
                   getFormByControlName.errors !== null); else formFilled" class="icon-mandatory">*</span>
      <ng-template #formFilled><span class="icon-mandatory-filled">*</span></ng-template>
    </div>

    <div *ngIf="(getControlNameDetail && getControlNameDetail.disabled && getControlNameDetail?.value) || config.presentation === 'detail'" style="width: 100%;">
<!--       simple-->
      <label *ngIf="config.options.show" style="font-weight: bold;">{{getControlNameDetail?.value}}</label>


    </div>
    <div *ngIf="(getControlNameDetail && getControlNameDetail.disabled && !getControlNameDetail?.value) || config.presentation === 'detail'" style="width: 100%;">

      <input class="form-control"
             id="{{config.label}}"
             autocomplete="off"
             [formControlName]="getControlName"
             [typeahead]="datas"
             [typeaheadOptionsLimit]="20"
             [disabled]="true"
             [tooltip]="config.options.disableMessage"
             [typeaheadMinLength]="0">

    </div>
    <ng-template *ngIf="config.presentation === 'filter'">
      <input class="form-control"
             id="{{config.label}}"
             autocomplete="off"
             [formControlName]="getControlName"
             [typeahead]="datas | async"
             [typeaheadOptionsLimit]="20"
             [typeaheadMinLength]="0">
    </ng-template>

  </div>
</div>
<div *ngIf="false" style="display:flex;">

  <pre style="flex:1;word-break:break-word;line-height:2;">getControlName: {{getControlName}}</pre>
  <pre style="flex:1;word-break:break-word;line-height:2;">vue: {{config.options.vue}}</pre>
<!--  <pre>datas{{ datas | async | json}}</pre>-->
</div>
